import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import { toast } from "react-toastify";
import ConfirmActionDialog from "../../../components/ConfirmActionDialog";
import { deleteDevice } from "../../../axios/User/UserApi";

const UnregisterDeviceDialog = ({ infoDevice, onClose, onRefresh }) => {
  const { t } = useTranslation();
  const [loading, setLoading] = useState(false);

  const handleClose = () => {
    if (loading) return;
    onClose?.();
  };

  const handleDelete = async () => {
    setLoading(true);
    try {
      const payload = {
        deviceId: infoDevice?.id,
        langId: localStorage.getItem("i18nextLngId"),
      };

      await deleteDevice(payload);

      toast.success(t("common.delete-device-successfully"));
      onRefresh?.();
      onClose?.();
    } catch (err) {
      console.error("Error deleting device:", err);
      toast.error(err?.response?.data?.message);
    } finally {
      setLoading(false);
    }
  };

  return (
    <ConfirmActionDialog
      open
      variant="warning"
      title={t("common.unregister-device")}
      subtitle={t("common.are-you-sure-you-want-to-unregister")}
      confirmText={t("button.confirm")}
      loading={loading}
      onClose={handleClose}
      onConfirm={handleDelete}
    />
  );
};

export default UnregisterDeviceDialog;
